import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastController } from "@ionic/angular";
//import * as moment from "moment";
import moment from 'moment';
import { Observable, of } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { AuthService } from "src/app/auth/services/auth.service";
import { PageService } from "src/app/services/page.service";
import { SettingService } from "src/app/shared/services/setting.service";
import { ICustomerTransactionEmail, IDisplayTaxes } from "src/app/store/components/receipt/receipt.component";
import { ICustomerReservationTransactionEmail } from "src/app/store/components/reservation-receipt/reservation-receipt.component";
import { ICreditCard } from "src/app/store/services/order.service";
import { ITranslatableText } from "src/app/store/services/store.service";
import { IAddress } from "./address.service";
import { TranslationService } from "./translation.service";
import { ApiControllerService } from "./api-controller.service";

export interface ITable {
   id? : string,
   storeId? : string,
   imageId: number,
   title: string,
   capacity: number,
   imageLink: string,
   tableAngle: number,
   top : string,
   left : string,
   layoutId : number,
   number : number,
   sectionSelected : boolean,
   tableSelected : boolean,
   tableBlockSelected : boolean,
   tableJoinSelected : boolean,
   reservationTableSelected : boolean,
   tableBlocked : boolean,
   currentBookingEndTime? : Date,
   bookingTimes? : Date[],
   cleaningRequired : boolean
}

export interface ICreateReservation{
   locationId: number,
   name: string
   date: string,
   time: string,
   count: number,
   countChildren: number,
   countHighChair: number,
   countBooster: number,
   specialRequest: string,
   email: string,
   phone: string,
   byMerchant: boolean,
   pageId: number,
   storeId: string,
   sectionId: string,
   reservationConfirmation : boolean
   language? : string;
   employeeId? : number;
   packages?: IReservationSectionPackage[];
   layout?: ILayoutDetails;
 }

 export interface IAgendaEvents {
   Id?: string;
   Start?: Date;
   Title?: string;
   AllDay?: boolean;
   Count?: number;
   Color?: string;
   Status?: string;
   TableSelectionOn? : boolean;
   TableAssigned? : number[];
   StoreId? : string;
   CountChildren? : number;
   CountHighChair? : number;
   CountBooster? : number;
   SpecialRequest? : string;
   Email? : string;
   Phone? : string;
   ReservationType? : string;
   ByMerchant? : boolean;
   ReservationComplete : boolean;
   ReservationNoShow : boolean;
   ReservationCancelled : boolean;
   CreatedDate?: Date;
   ConfirmByEmail? : boolean;
   ConfirmBySms? : boolean;
   Confirmed? : boolean;
   ConfirmedDate? : Date;
   CardId? : number;
   Language? : string;
   EmployeeId? : number;
   GoogleUserId?: string;
   PrepayReservation?: IPrepayReservation;
}

export interface IEmployee {
   EmployeeId? : number,
   LocationId? : number,
   JobTitleId? : number,
   Email? : string,
   FirstName? : string,
   LastName? : string,
   Lang? : string,
   Job_Title? : string,
   EmployeeSchedule? : IEmployeeSchedule[]
}

export interface IEmployeeSchedule{
   Day : number,
   TimeRange : IScheduleRange[],
 }
 
 export interface IScheduleRange{
   StartTime : string;
   EndTime : string;
 }

export interface ISection{
   Id? : string,
   StoreId : string,
   SectionName : string,
   Tables : string[]
   Employee? : number[],
   LayoutId : number,
   IsOrderTable?: boolean,
   StartTime?: string,
   EndTime?: string,
   Packages?: ISectionPackage[]
}

export interface ISectionPackage{
   ItemId : string,
   ItemName: ITranslatableText;
   ItemNumber: string;
   Description: ITranslatableText;
   Price: number;
   TaxEligible: boolean;
   ItemImageShortName: string
   IsActive?: boolean;
 }

export interface IReservationSectionPackage{
   ItemId: string;
   ItemName: ITranslatableText;
   ItemNumber: string;
   Description: ITranslatableText;
   Price: number;
   TaxEligible: boolean;
   ItemImageShortName: string
   Quantity: number;
   SpecialRequest: string;
}

export interface IStoreLayoutConfig {
   Id? : string,
   StoreId? : string,
   Layouts : string[],
   LayoutDetails: ILayoutDetails[],
   ServiceDetails? : IServiceDetails[],
   ServiceDetailsGroup? : IGroupServiceDetails[],
   ChairBooster:boolean,
   HighChair:boolean,
   Children:boolean,
   FriendOfOwner:boolean,
   VipTable:boolean,
   Allergies:boolean,
   SectionsIncluded : boolean,
   EmployeesIncluded : boolean,
   OnlineReservationLimit:number,
   EmailValidationRequired:boolean,
   ReservationTimeInterval:number,
   AllowDifferentLayouts: boolean
}
export interface ILayoutDetails {
   Name: string;
   LastUpdateDefault: Date;
 }
export interface IServiceDetails{
   ServiceName : string,
   ServiceTime : number
 }
 
 export interface IGroupServiceDetails{
   ServiceNameGroup : string,
   ServiceTimeGroup : number
 }

export interface IFindTableAvailability{
    totalGuests: number,
    reservationTime: Date,
    StoreId: string,
    SectionId: string,
    Layout: ILayoutDetails
  }

export interface IWaitlist {
   id?: string;
   storeId? : string;
   userIdentifier?: string;
   count?: number;
   countChildren? : number;
   countHighChair? : number;
   countBooster? : number;
   specialRequest? : string;
   name? :string;
   email? : string;
   phone? : string;
   language?: string;
   waitlistStartTime?: Date;
   sentMessage?: boolean;
   waitlistComplete? : boolean;
   waitlistNoShow? : boolean;
   waitlistCancelled? : boolean;
   cardId?: number;
   redirectId?: string;
}

export interface IReservation{
   specialRequest: string;
   packages: IReservationSectionPackage[];
}

export interface IPrepayReservation{
   ghostedPaymentCard: string;
   customerName: string;
   customerLastName: string;
   CustomerFirstName: string;
   customerEmail: string;
   customerPhone: string;
   billingAddress: IAddress;
   packages: IReservationSectionPackage[];
   ghostedGiftCard: string;
   paymentType: string;
   smaTerminalId: number;
   smaApiTransactionsId: number[];
   tip: number;
   convenienceFee: number;
   subTotal: number;
   total: number;
   giftAmount: number;
   rebateAmount: number;
   taxes: IDisplayTaxes[];
   voided: boolean;
   paid: boolean;
   completed: boolean;
   refunded: boolean;
   refundedAmount: number;
}

export interface IPlacePrepayReservationBase {
   merchantId: string;
   storeId: string;
   reservation: IReservation;
   customerFirstName: string;
   customerLastName: string;
   customerName: string;
   customerEmail: string;
   phone: string;
   reservationTip: number;
   language: string;
   reservationDate: string;
   reservationTime: string;
   giftCard?: string;
   eCouponCode?: string;
   convenienceFee:number;

}

export interface IMemberPlacePrepayReservation extends IPlacePrepayReservationBase {
   cvn: number;
   savedCardId: string;
}

export interface IPlacePrepayReservation extends IPlacePrepayReservationBase {
   creditCard?: ICreditCard;
   billingAddress: IAddress;
}

@Injectable({
   providedIn: 'root'
  })
export class ReservationService{
   constructor(private http: HttpClient, 
      private setting: SettingService,
      private auth: AuthService,
      private page: PageService,
      //private translateService: TranslateService,
      private toastCtrl: ToastController,
      private translationService: TranslationService,
      private apiController: ApiControllerService) { }

   getTableAvailability(findTableAvailabilityModel: IFindTableAvailability) : Observable<ITable[]> {
      return Observable.create(o => {
         /* this.http.post(this.setting.getLegacySmaUrl('V2/Agenda/GetTableAvailability'),findTableAvailabilityModel, {
            responseType: 'json'
         })
            .subscribe((data: ITable[]) => {
               o.next(data);
               o.complete();
            }); */
         this.apiController.post(this.setting.getLegacySmaUrl('V2/Agenda/GetTableAvailability'),findTableAvailabilityModel, {
            responseType: 'json'
         })
            .subscribe((data: ITable[]) => {
               o.next(data);
               o.complete();
            });
      })
   }
   getSections(storeId: string) : Observable<ISection[]> {
      return Observable.create(o => {
         /*  this.http.post(this.setting.getLegacySmaUrl('V2/Agenda/GetSectionDetails'), {
            storeId: storeId
         })
            .subscribe((data: ISection[]) => {
               o.next(data);
               o.complete();
            }); */
         
         this.apiController.post(this.setting.getLegacySmaUrl('V2/Agenda/GetSectionDetails'), {
            storeId: storeId
         })
            .subscribe((data: ISection[]) => {
               o.next(data);
               o.complete();
            });
      })
   }

   getWebServerEmployees(externalProviderId: string) : Observable<IEmployee[]> {
      return Observable.create(o => {
         /* this.http.post(this.setting.getLegacySmaUrl('V2/Agenda/GetEmployee'), {
            externalProviderId : externalProviderId
         })
            .subscribe((data: IEmployee[]) => {
            o.next(data);
            o.complete();
            }); */

         this.apiController.post(this.setting.getLegacySmaUrl('V2/Agenda/GetEmployee'), {
            externalProviderId : externalProviderId
         })
            .subscribe((data: IEmployee[]) => {
               o.next(data);
               o.complete();
            });
      })
   }

   getStoreEmployees(externalProviderId: string) : Observable<IEmployee[]> {
      return Observable.create(o => {
         /* this.http.post(this.setting.getLegacySmaUrl('V2/Agenda/GetSMSEmployees'), {
            externalProviderId : externalProviderId
         })
            .subscribe((data: IEmployee[]) => {
               o.next(data);
               o.complete();
            }); */
         
         this.apiController.post(this.setting.getLegacySmaUrl('V2/Agenda/GetSMSEmployees'), {
            externalProviderId : externalProviderId
         })
            .subscribe((data: IEmployee[]) => {
               o.next(data);
               o.complete();
            });
       })
   }
   
   createReservation(createReservation: ICreateReservation) : Observable<string> {
      return Observable.create(o => {
         /* this.http.post(this.setting.getLegacySmaUrl('V2/Agenda/CreateReservation'),createReservation, {
            responseType: 'text'
         })
            .subscribe((data: string) => {
               o.next(data);
               o.complete();
            }); */

         this.apiController.post(this.setting.getLegacySmaUrl('V2/Agenda/CreateReservation'),createReservation, {
            responseType: 'text'
         })
            .subscribe((data: string) => {
               o.next(data);
               o.complete();
            });
      })
   }
   updateReservation(reservationModel: IAgendaEvents) : Observable<string> {
      return Observable.create(o => {
         /* this.http.post(this.setting.getLegacySmaUrl('V2/Agenda/UpdateReservation'),reservationModel, {
            responseType: 'text'
         })
            .subscribe((data: string) => {
               o.next(data);
               o.complete();
            }); */

         this.apiController.post(this.setting.getLegacySmaUrl('V2/Agenda/UpdateReservation'),reservationModel, {
            responseType: 'text'
         })
            .subscribe((data: string) => {
               o.next(data);
               o.complete();
            });
      })
   }
   confirmReservation(id: string) : Observable<string> {
      return Observable.create(o => {
         /* this.http.post(this.setting.getLegacySmaUrl('V2/Agenda/ConfirmReservation'), {
            id : id
         })
            .subscribe((data: string) => {
               o.next(data);
               o.complete();
            }); */
         
         this.apiController.post(this.setting.getLegacySmaUrl('V2/Agenda/ConfirmReservation'), {
            id : id
         })
            .subscribe((data: string) => {
               o.next(data);
               o.complete();
            });
      })
   }
   cancelReservation(id: string) : Observable<boolean> {
      return Observable.create(o => {
         /* this.http.post(this.setting.getLegacySmaUrl('V2/Agenda/CancelReservation'), {
            id : id
         })
            .subscribe((data: boolean) => {
               o.next(data);
               o.complete();
            }); */

            this.apiController.post(this.setting.getLegacySmaUrl('V2/Agenda/CancelReservation'), {
               id : id
            })
               .subscribe((data: boolean) => {
                  o.next(data);
                  o.complete();
               });
      })
   }
   notifyCreateReservation(id: string): Observable<string> {
      return Observable.create(o => {
         /* this.http.post(this.setting.apiUrl('/Reservation/notifyCreateReservation'), { id: id }, {
            responseType: 'text'
         })
         .subscribe((data: string) => {
            o.next(data);
            o.complete();
         }); */

         this.apiController.post(this.setting.apiUrl('/Reservation/notifyCreateReservation'), { id: id }, {
            responseType: 'text'
         })
         .subscribe((data: string) => {
            o.next(data);
            o.complete();
         });
      })
   };
   getLayoutInfo(storeId: string) : Observable<IStoreLayoutConfig> {
      return Observable.create(o => {
        /* this.http.post(this.setting.getLegacySmaUrl('V2/Agenda/GetLayoutDetails'), {
         storeId: storeId
        })
         .subscribe((data: IStoreLayoutConfig) => {
           o.next(data);
           o.complete();
         }); */

         this.apiController.post(this.setting.getLegacySmaUrl('V2/Agenda/GetLayoutDetails'), {
            storeId: storeId
         })
         .subscribe((data: IStoreLayoutConfig) => {
           o.next(data);
           o.complete();
         });
      })
   }
   GetStoreTablesDetails(storeId: string) : Observable<boolean> {
      return Observable.create(o => {
         /* this.http.post(this.setting.getLegacySmaUrl('V2/Agenda/GetStoreTablesDetails'), {
            storeId: storeId
         })
         .subscribe((data: boolean) => {
           o.next(data);
           o.complete();
         }); */

         this.apiController.post(this.setting.getLegacySmaUrl('V2/Agenda/GetStoreTablesDetails'), {
            storeId: storeId
         })
         .subscribe((data: boolean) => {
           o.next(data);
           o.complete();
         });
         
       })
   }
   getAgendaInfo(id: string) : Observable<IAgendaEvents> {
      return Observable.create(o => {
         /* this.http.post(this.setting.getLegacySmaUrl('V2/Agenda/GetCurrentReservation'), {
            id : id
         })
         .subscribe((data: IAgendaEvents) => {
           o.next(data);
           o.complete();
         }); */

         this.apiController.post(this.setting.getLegacySmaUrl('V2/Agenda/GetCurrentReservation'), {
            id : id
         })
         .subscribe((data: IAgendaEvents) => {
           o.next(data);
           o.complete();
         });
      })
   }
   createWaitlist(waitlist: IWaitlist): Observable<IWaitlist> {
      return Observable.create(o => {
         /* this.http.post(this.setting.apiUrl('/Reservation/createWaitlist'), waitlist)
         .subscribe((id: string) => {
            o.next(id);
            o.complete();
         }); */

         this.apiController.post(this.setting.apiUrl('/Reservation/createWaitlist'), waitlist)
         .subscribe((id: string) => {
            o.next(id);
            o.complete();
         });
      })
   };
   getWaitlistInfo(id: string) : Observable<IWaitlist> {
      return Observable.create(o => {
        /* this.http.post(this.setting.apiUrl('reservation/findWaitlist'), {
            id: id
        })
        .pipe(
            catchError(() => { return of(null) }),
            finalize(() => {
               o.complete();
            })
         )
         .subscribe((data: IWaitlist) => {
           o.next(data);
           o.complete();
         }); */

         this.apiController.post(this.setting.apiUrl('reservation/findWaitlist'), {
            id: id
         })
         .pipe(
               catchError(() => { return of(null) }),
               finalize(() => {
                  o.complete();
               })
            )
            .subscribe((data: IWaitlist) => {
               o.next(data);
               o.complete();
            });
       })
   }
   getRedirectWaitlistInfo(redirectId: string) : Observable<IWaitlist> {
      return Observable.create(o => {
        /*  this.http.post(this.setting.apiUrl('reservation/findRedirectWaitlist'), {
            redirectId: redirectId
         })
         .subscribe((data: IWaitlist) => {
            o.next(data);
            o.complete();
         }); */

         this.apiController.post(this.setting.apiUrl('reservation/findRedirectWaitlist'), {
            redirectId: redirectId
         })
         .subscribe((data: IWaitlist) => {
            o.next(data);
            o.complete();
         });
      })
   }
   getAllNotCompletedWaitlists(storeId: string) : Observable<IWaitlist[]> {
      return Observable.create(o => {
         /* this.http.post(this.setting.apiUrl('reservation/findAllNotCompletedWaitlists'), {
            storeId: storeId
         })
         .subscribe((data: IWaitlist) => {
           o.next(data);
           o.complete();
         }); */

         this.apiController.post(this.setting.apiUrl('reservation/findAllNotCompletedWaitlists'), {
            storeId: storeId
         })
         .subscribe((data: IWaitlist) => {
           o.next(data);
           o.complete();
         });
       })
   }
   getWaitlistSubdomain(storeId: string): Observable<string> {
      return Observable.create(o => {
         /* this.http.post(this.setting.apiUrl('reservation/FindWaitlistSubdomain'), { storeId: storeId }, {
            responseType: 'text'
         })
         .subscribe((data: string) => {
            o.next(data);
            o.complete();
         }); */

         this.apiController.post(this.setting.apiUrl('reservation/FindWaitlistSubdomain'), { storeId: storeId }, {
            responseType: 'text'
         })
         .subscribe((data: string) => {
            o.next(data);
            o.complete();
         });
      });
   }

   placePrepayReservation(reservation: IPlacePrepayReservation): Observable<ICustomerReservationTransactionEmail> {
        
      //When it is a 100% gift card transaction, must set a date for the expiration and the number = 0 otherwise the server freakout with his model
      if (reservation.creditCard.expirationDate == "Invalid date") {
         reservation.creditCard.expirationDate = moment().format("YYYY-MM-DD");
         reservation.creditCard.number = 0;
      }

       //Now that the cvc input is a password field, must change the input value from string to number if it is a valid number. If not, 
      //the server will reject the cvc number not being able to convert it to int
      if (!isNaN(reservation.creditCard.cvnNumber)) {
         reservation.creditCard.cvnNumber = Number(reservation.creditCard.cvnNumber);
      }

      return Observable.create(o => {
            /* this.http.post(this.setting.apiUrl('Reservation/PlacePrepayReservation'), reservation)
              .pipe(finalize(() => {
                  o.complete();
              }))
              .subscribe((data: ICustomerTransactionEmail) => {
                  o.next(data);
              }, async error => {
                
                  let message = this.translationService.translate("Checkout.InvalidOrder")
                  if(error)
                  {

                  }
               
                  const toast = await this.toastCtrl.create({
                      message: message,
                      position: 'bottom',
                      color: 'danger',
                      cssClass: 'order-toast',
                      buttons: [
                        {
                          side: 'start',
                          icon: 'alert-circle-outline',
                          //cssClass: 'order-error-icon',
                          text: '',
                          handler: () => {
            
                          }
                        }, {
                          text: this.translationService.translate("General.Close"),
                          role: 'cancel',
                          handler: () => {
            
                          }
                        }
                      ]
                    });
                    await toast.present();                   
              }); */

            this.apiController.post(this.setting.apiUrl('Reservation/PlacePrepayReservation'), reservation)
              .pipe(finalize(() => {
                  o.complete();
              }))
              .subscribe((data: ICustomerTransactionEmail) => {
                  o.next(data);
              }, async error => {
                
                  let message = this.translationService.translate("Checkout.InvalidOrder")
                  if(error)
                  {

                  }
               
                  const toast = await this.toastCtrl.create({
                      message: message,
                      position: 'bottom',
                      color: 'danger',
                      cssClass: 'order-toast',
                      buttons: [
                        {
                          side: 'start',
                          icon: 'alert-circle-outline',
                          //cssClass: 'order-error-icon',
                          text: '',
                          handler: () => {
            
                          }
                        }, {
                          text: this.translationService.translate("General.Close"),
                          role: 'cancel',
                          handler: () => {
            
                          }
                        }
                      ]
                    });
                    await toast.present();                   
              });
      });
   }

   memberPlacePrepayReservation(reservation: IMemberPlacePrepayReservation): Observable<ICustomerReservationTransactionEmail> {
      //Now that the cvc input is a password field, must change the input value from string to number if it is a valid number. If not, 
    //the server will reject the cvc number not being able to convert it to int
    //debugger;        
    if (!isNaN(reservation.cvn)) {
      reservation.cvn = Number(reservation.cvn);
    }

    return Observable.create(o => {
        let headers = this.auth.getAuthHeadersBaseObject();
        this.page.appendAuthorizationHeader(headers);
 
         /* this.http.post(this.setting.apiUrl('Reservation/MemberPlacePrepayReservation'),
            reservation,
            { headers: headers }
         )
            .pipe(finalize(() => {
                o.complete();
            }))
            .subscribe((data: ICustomerTransactionEmail) => {
                o.next(data);
            }, async error => {
              
                let message = this.translationService.translate("Checkout.InvalidOrder")
                if(error)
                {
           
                }

                const toast = await this.toastCtrl.create({
                    message: message,
                    position: 'bottom',
                    color: 'danger',
                    cssClass: 'order-toast',
                    buttons: [
                      {
                        side: 'start',
                        icon: 'alert-circle-outline',
                        //cssClass: 'order-error-icon',
                        text: '',
                        handler: () => {
          
                        }
                      }, {
                        text: this.translationService.translate("General.Close"),
                        role: 'cancel',
                        handler: () => {
          
                        }
                      }
                    ]
                  });
                  await toast.present();                   
            }); */

         this.apiController.post(this.setting.apiUrl('Reservation/MemberPlacePrepayReservation'),
            reservation,
            { headers: headers }
         )
            .pipe(finalize(() => {
                o.complete();
            }))
            .subscribe((data: ICustomerTransactionEmail) => {
                o.next(data);
            }, async error => {
              
                let message = this.translationService.translate("Checkout.InvalidOrder")
                if(error)
                {
           
                }

                const toast = await this.toastCtrl.create({
                    message: message,
                    position: 'bottom',
                    color: 'danger',
                    cssClass: 'order-toast',
                    buttons: [
                      {
                        side: 'start',
                        icon: 'alert-circle-outline',
                        //cssClass: 'order-error-icon',
                        text: '',
                        handler: () => {
          
                        }
                      }, {
                        text: this.translationService.translate("General.Close"),
                        role: 'cancel',
                        handler: () => {
          
                        }
                      }
                    ]
                  });
                  await toast.present();                   
            });
    });
   }

   getTable(tableId: string, storeId: string = null, tableNumber: number = -1) : Observable<ITable> {
      return Observable.create(o => {
         /* this.http.post(this.setting.apiUrl('reservation/findReservationTable'), {
            tableId: tableId,
            storeId: storeId,
            tableNumber: tableNumber
         })
         .pipe(
            catchError(() => { return of(null) }),
            finalize(() => {
               o.complete();
            })
         )
         .subscribe((data: ITable) => {
           o.next(data);
           o.complete();
         }); */

         this.apiController.post(this.setting.apiUrl('reservation/findReservationTable'), {
            tableId: tableId,
            storeId: storeId,
            tableNumber: tableNumber
         })
         .pipe(
            catchError(() => { return of(null) }),
            finalize(() => {
               o.complete();
            })
         )
         .subscribe((data: ITable) => {
           o.next(data);
           o.complete();
         });
      })
   }
}